import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Typography, TextField, Button } from '@material-ui/core';

import { findPassword, notiChangePassword } from 'lib/api/auth';

import BasicModalSection from 'components/molecules/Modal/Section';
import BasicModalFooter from 'components/molecules/Modal/Footer';
import BasicModal from 'components/organisms/Modal/Basic';

import FormWrap from 'pages/Login/FormWrap';

const useStyles = makeStyles((theme) => ({
  textField: {
    '& input': {
      height: 50,
      boxSizing: 'border-box',
      '&::-ms-clear': {
        display: 'none',
      },
    },
  },
  errorMessage: {
    maxWidth: 355,
    marginTop: theme.spacing(1),
    color: theme.palette.primary.error,
    fontSize: theme.palette.primary.defaultTextSize,
    fontWeight: 'bold',
  },
  submitBtn: {
    width: '100%',
    marginTop: theme.spacing(3),
    color: '#fff',
  },
}));

const LoginForm = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);
  const [findPasswordState, setFindPasswordState] = useState(false);
  const [findPasswordData, setFindPasswordData] = useState({
    email: '',
    emailMessage: '',
    emailError: false,
    userId: '',
    newPassword: {
      password: '',
      message: '',
      error: false,
    },
    confirmPassword: {
      password: '',
      message: '',
      error: false,
    },
    changeFailed: true,
    changeFailedMessage: '',
    scucessState: 0,
    modalState: false,
    sendEmailBtnDisable: true,
    changePwBtnDisable: true,
  });

  // 페이지 로딩 시 도메인에서 userId를 구분해서 랜더링 시켜주는 코드
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQuery();
  function checkUserId() {
    let routerUerId = query.get('userId');

    if (routerUerId === null) {
      setFindPasswordState(false);
    } else {
      setFindPasswordState(true);
      setFindPasswordData({
        ...findPasswordData,
        userId: query.get('userId'),
      });
    }
  }

  // 랜더링 되었을 때 한번만 실행되도록 하는 코드
  useEffect(checkUserId, []);

  // 이메일 주소 입력 INPUT에서 유효성 검사해주는 핸들
  const handleEmailData = (e) => {
    const { value } = e.target;
    const emailRegexp = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    if (emailRegexp.test(value)) {
      setFindPasswordData({
        ...findPasswordData,
        email: value,
        sendEmailBtnDisable: false,
      });
    } else {
      setFindPasswordData({
        ...findPasswordData,
        email: value,
        sendEmailBtnDisable: true,
      });
    }
  };

  // 변경 할 패스워드 입력 시 데이터 넣어주는 핸들
  const handleData = (e) => {
    const { value, name } = e.target;
    const regexp = /^[A-Za-z0-9~!@#$%^&*()_+|<>?:{}+]{8,14}$/;

    let pageValue = {
      ...findPasswordData,
      [e.target.name]: {
        password: e.target.value,
      },
    };

    if (regexp.test(value)) {
      switch (name) {
        case 'newPassword':
          if (value === pageValue.confirmPassword.password) {
            pageValue = {
              ...pageValue,
              confirmPassword: {
                ...pageValue.confirmPassword,
                message: '',
                error: false,
              },
              changePwBtnDisable: false,
            };
          } else {
            pageValue = {
              ...pageValue,
              confirmPassword: {
                ...pageValue.confirmPassword,
                message: t('패스워드가 일치하지 않습니다.'),
                error: true,
              },
              changePwBtnDisable: true,
            };
          }
          break;
        case 'confirmPassword':
          if (value === pageValue.newPassword.password) {
            pageValue = {
              ...pageValue,
              confirmPassword: {
                ...pageValue.confirmPassword,
                message: '',
                error: false,
              },
              changePwBtnDisable: false,
            };
          } else {
            pageValue = {
              ...pageValue,
              confirmPassword: {
                ...pageValue[e.target.name],
                message: t('패스워드가 일치하지 않습니다.'),
                error: true,
              },
              changePwBtnDisable: true,
            };
          }
          break;
        default:
          break;
      }
    } else {
      switch (name) {
        case 'newPassword':
          if (value === '') {
            pageValue = {
              ...pageValue,
              [e.target.name]: {
                ...pageValue[e.target.name],
                message: t('비밀번호를 입력해 주세요.'),
                error: true,
              },
              changePwBtnDisable: true,
            };
          } else {
            pageValue = {
              ...pageValue,
              [e.target.name]: {
                ...pageValue[e.target.name],
                message: t(
                  '8~14자 영문 대 소문자, 숫자, 특수문자를 사용하세요.'
                ),
                error: true,
              },
              changePwBtnDisable: true,
            };
          }
          break;
        case 'confirmPassword':
          if (value === '') {
            pageValue = {
              ...pageValue,
              [e.target.name]: {
                ...pageValue[e.target.name],
                message: t('비밀번호를 입력해 주세요.'),
                error: true,
              },
              changePwBtnDisable: true,
            };
          } else {
            pageValue = {
              ...pageValue,
              [e.target.name]: {
                ...pageValue[e.target.name],
                message: t(
                  '8~14자 영문 대 소문자, 숫자, 특수문자를 사용하세요.'
                ),
                error: true,
              },
              changePwBtnDisable: true,
            };
          }
          break;
        default:
          break;
      }
    }
    setFindPasswordData(pageValue);
  };

  // 비밀번호 변경 알림 요청 API
  const handleSendEmail = (e) => {
    e.preventDefault();
    findPassword(findPasswordData.email)
      .then((response) => {
        const { success } = response.data;
        if (success) {
          setFindPasswordData({
            ...findPasswordData,
            emailMessage: t(
              '이메일 인증 요청이 되었습니다. 이메일을 확인해주세요.'
            ),
            emailError: false,
          });
        } else if (success === false) {
          setFindPasswordData({
            ...findPasswordData,
            changeFailed: true,
            emailMessage: response.data.message,
            emailError: true,
          });
        }
      })
      .catch((error) => {
        setFindPasswordData({
          ...findPasswordData,
          emailMessage: error.message,
          emailError: false,
        });
      });
  };

  // 패스워드 변경 요청 API
  const handleChangePassword = (e) => {
    e.preventDefault();
    notiChangePassword(
      findPasswordData.userId,
      findPasswordData.newPassword.password,
      findPasswordData.confirmPassword.password
    )
      .then((response) => {
        const { success } = response.data;
        if (success) {
          setOpenModal(true);
        } else if (success === false) {
          setFindPasswordData({
            ...findPasswordData,
            changeFailed: success,
            changeFailedMessage: response.data.message,
          });
        }
      })
      .catch((error) => {
        alert(t('비밀번호 변경에 실패하였습니다. 관리자에게 문의해주세요.'));
      });
  };

  return (
    <FormWrap>
      {!findPasswordState ? (
        <>
          <form
            noValidate
            autoComplete="off"
            className={classes.loginFormWrap}
            onSubmit={handleSendEmail}
          >
            <TextField
              required
              label="Email"
              name="email"
              className={classes.textField}
              margin="normal"
              type="email"
              variant="outlined"
              onChange={handleEmailData}
            />
            <div>
              {findPasswordData.emailError ? (
                <FormHelperText
                  className={`${classes.errorInfoText} errorInfoText`}
                >
                  {findPasswordData.emailMessage}
                </FormHelperText>
              ) : (
                <FormHelperText className={`${classes.errorInfoText}`}>
                  {findPasswordData.emailMessage}
                </FormHelperText>
              )}
            </div>

            <Button
              type="submit"
              variant="contained"
              size="large"
              color="primary"
              disabled={findPasswordData.sendEmailBtnDisable}
              onClick={handleSendEmail}
              className={`${classes.whiteText} ${classes.submitBtn}`}
            >
              {t('이메일 전송')}
            </Button>
          </form>
        </>
      ) : (
        <>
          <form
            className={classes.loginFormWrap}
            autoComplete="off"
            onSubmit={handleChangePassword}
          >
            <TextField
              error={findPasswordData.newPassword.error}
              name="newPassword"
              type="password"
              label={t('비밀번호')}
              className={classes.textField}
              margin="normal"
              variant="outlined"
              onChange={handleData}
            />
            <FormHelperText
              className={`${classes.errorInfoText} errorInfoText`}
            >
              {findPasswordData.newPassword.message}
            </FormHelperText>
            <TextField
              error={findPasswordData.confirmPassword.error}
              name="confirmPassword"
              label={t('비밀번호 확인')}
              type="password"
              className={classes.textField}
              autoComplete="current-password"
              margin="normal"
              variant="outlined"
              onChange={handleData}
            />
            <FormHelperText
              className={`${classes.errorInfoText} errorInfoText`}
            >
              {findPasswordData.confirmPassword.message}
            </FormHelperText>

            <div className={classes.loginOption}>
              <Typography className={classes.errorMessage} variant="body1">
                {findPasswordData.changeFailedMessage}
              </Typography>
            </div>
            <div>
              {findPasswordData.changeFailed ? (
                <>
                  <Button
                    disabled={findPasswordData.changePwBtnDisable}
                    type="submit"
                    variant="contained"
                    size="large"
                    color="primary"
                    className={`${classes.whiteText} ${classes.submitBtn}`}
                    onClick={handleChangePassword}
                  >
                    {t('비밀번호 재설정')}
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    color="primary"
                    className={`${classes.whiteText} ${classes.submitBtn}`}
                    href="/findPassword"
                  >
                    {t('비밀번호 알림 재요청')}
                  </Button>
                </>
              )}
            </div>
          </form>
          <BasicModal open={openModal}>
            <BasicModalSection textContent={t('비밀번호가 변경되었습니다.')} />
            <BasicModalFooter
              confirmOnClick={() => window.location.replace('/')}
              cancelBtnOpen={false}
              confirmBtnOpen={true}
              confirmBtnTitle={t('확인')}
            />
          </BasicModal>
        </>
      )}
    </FormWrap>
  );
};

export default LoginForm;
